import React, { useState, useEffect, useContext } from 'react';

import { Link } from 'react-router-dom';

import {
    Dropdown,
    Typography,
    Skeleton,
    Popconfirm,
    message,
    Modal,
    Form,
    Input,
    Tabs,
    Tag,
    Menu,
    Alert,
    Collapse,
    Divider,
    Row,
    Col,
    Space,
} from 'antd';

import { GlobalContext, Location, ApiUtils, Camera, useTranslation, ConsentComponent, Card, Button} from 'soxo-bootstrap-core';

import { Appointments, DocDetails, Items } from './../../../../models/';

import PaymentLink from '../../../common/components/payment-link/payment-link';

import StatusChange from '../status-change/status-change';
import PreviewMails from '../../../../components/preview-mails/preview-mails';
import UploadId from './../upload-id';

import moment from 'moment-timezone';

import DocumentUploadComponent from '../../../emr/components/document-upload/document-upload';

import './appointment-detail.scss';

import { SendOutlined, EyeOutlined, MailOutlined, DatabaseOutlined, DownOutlined,FileAddOutlined} from '@ant-design/icons';

import OutboxList from '../../../outbox-list/outbox-list';

import GuestInfo from '../../../common/components/guest-info/guest-info';

import DocumentPreview from './../../../../components/document-preview/document-preview';
// import Payment from '../../../candidate-visit/payment';
// import SendReport from '../../../common/components/send-report/send-report';
import PrintPreview from '../../../common/components/print-preview/print-preview';
// import { func } from 'prop-types';
import PaymentList from '../../../payment-list/payment-list';

import ProfileModel from '../../../common/components/complete-profile-model/complete-profile-model';
// import StatusChange from '../status-change/status-change';

import SendReport from '../../../common/components/send-report/send-report';
import SendImageLink from '../../../common/components/send-image-link/send-image-link';
import PriceFormatter from '../../../common/components/format-price/format-price';
import { DocumentUpload } from '../../../emr/components/emr-screen/documents/documents';
import AuditLogList from '../../../audit-log/audit-log';
import Coupon from '../../../common/components/coupon/coupon';
import ConsentUploader from '../../../../components/consent-uploader/consent-uploader';

const { Title, Text } = Typography;

const { TabPane } = Tabs;

const { Panel } = Collapse;

const layout = {
    labelCol: {
        xs: { span: 8 },
        sm: { span: 8 },
        lg: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 8 },
        sm: { span: 8 },
        lg: { span: 8 },
    },
};

const { TextArea } = Input;
const { confirm } = Modal; // for confirmation

/**
 * Appointment Detail Screen
 *
 * @param {*} props
 * @returns
 */
export default function AppointmentDetail(props) {
    // Url Params
    const { user = {}, isMobile } = useContext(GlobalContext);

    const [loading, setLoading] = useState(false);

    //Get pagination number
    const { id } = props.match.params;

    const [guest, setGuest] = useState({});

    //Visibilty setting for sendmail modal

    const [sendMailModalVisible, setSendMailReportModalVisible] = useState(false);

    const [status, setStatus] = useState({}); // To record process status

    const [form] = Form.useForm();

    const [visible, setVisible] = useState(false);

    const [outBoxModel, setOutBoxModel] = useState(false);

    const [reportModalVisible, setReportModalVisible] = useState(false);

    const [reportSendModelVisible, setReportSendModalVisible] = useState(false);
    // payment link
    const [isModalVisible, setIsModalVisible] = useState(false);

    const [paymentView, setPaymentView] = useState(false);

    // const [showAlert, setShowAlert] = useState(false);

    // To check if the appointment is scheduled for the same date to enable registration
    const [sameDay, setSameDay] = useState(false);
    // for package
    const [selected, setSelected] = useState({});
    const [total, setTotal] = useState(null);

    const [item, setItems] = useState(null);

    const [nature, setNature] = useState(); // set otherdetails values from 'firmmas'

    const { t, i18n } = useTranslation(); // To Translate to another language

    // console.log(props.match.params);

    //PatiantData fetching function
    async function getAppointments(id) {
        setLoading(true);

        Appointments.getAppointmentRecord(id).then(async (res) => {
            var result = res;

            // If appointment date is today REgister button should be enabled
            const appointmentDate = moment(result.data.appointment_date, 'YYYY-MM-DD').valueOf();

            const currentDate = moment().startOf('day').valueOf();

            // sameDay is used to check if the apointment is on current date
            if (appointmentDate === currentDate) {
                setSameDay(true);
            }

            setGuest(result.data);

            setStatus(result.data.process_info);

            // setGuestOpReg(res.opreg);

            // setGuestItem(result.item);

            // setGuestPreReg(result.preReg);
            // setNature(result.data.nature);

            // if (result.opbill) setGuestOpBill(result.opbill);
            // if the corperate selected during appoinmnets .want to check this corperate are allow to uplaod Id cards
            // if (result.da_corporateptr) await getCorperateData(result.da_corporateptr);
            setLoading(false);
        });
    }

    useEffect(() => {
        if (user) {
            getAppointments(id);
        }
    }, [user]);

    function refresh() {
        getAppointments(guest.appointment_id);
        getSelectedPackage(guest.packagetypevalue);
    }

    //Cancellation of Appointment
    function onCancelAppointment() {
        form.validateFields()
            .then((values) => {
                let updateParams = {
                    cancel_flag: true,
                    da_canuser: user.email,
                    da_canuserid: user.id,
                    da_canremarks: values.remarks,
                };

                // cancel the appointment
                Appointments.cancelAppointment(id, updateParams).then(() => {
                    // setShowAlert(true);
                    setVisible(false);
                    Location.navigate({ url: `/appointments` });
                    message.success('Appointment is Cancelled');
                });
            })
            .catch((info) => {
                // console.log('Validate Failed:', info);
                setVisible(false);
            });
    }
    useEffect(() => {
        getSelectedPackage(guest.packagetypevalue);
    }, [guest.packagetypevalue]);
    /**
     *Get Selected package
     */
    function getSelectedPackage(packagetypevalue) {
        Items.getItems(packagetypevalue).then(async (result) => {
            setSelected(result);
            setItems(result);

            // setGender(result.itm_gender);
            // If total has not been set
            if (total === null) setTotal(result.ir_rate);
        });
    }

    /**
     * The function editAppointment is used to edit an appointment.
     */
    var date = moment(guest.appointment_date).format('DD/MM/YYYY');
    // Add time to appoinmtment time, to pass selected_time in the url for edit
    date = date + ' ' + guest.appointment_time;

    function editAppointment() {
        Location.navigate({
            url: `/new-registrations/edit-guest?da_id=${guest.appointment_id}&da_packagetypevalue=${guest.packagetypevalue}&id=${
                guest.reference_id
            }&prereg_opno=${guest.op_no}&selected_time=${date}&selected_date=${moment(guest.appointment_date).format(
                'YYYY-MM-DD'
            )}&edit=true&redirect=appointment`,
        });
    }

    /**
     *
     */

    async function sendGoogleReviewMail() {
        const result = await ApiUtils.post({ url: `opbill/google-review-mail?billId=${guest.bill_id}` });

        message.success('Mail send');
    }

    /**
     * The function `accessProfileAccount` sends a POST request to a specified endpoint with a JSON
     * payload, and if the response is successful, it opens a new window with the URL received in the
     * response.
     */
    const accessProfile = async () => {
        let formBody = {
            id: guest.appointment_id,
        };

        try {
            Appointments.accessProfileAccount(formBody).then(async (res) => {
                var ProfileUrl = res.data.orderUrl;
                window.open(ProfileUrl);
            });
        } catch (error) {
            console.error('Error during registration:', error);
        }
    };

    let config = {};

    // resend mail
    async function resendEmails() {
        const result = await ApiUtils.get({ url: `mail/resend-appointment-details?id=${guest.appointment_id}` });

        message.success('Mail/SMS Confirmation send');
    }

    // send fitkit mail
    const sendFitkitMail = async () => {
        const id = guest.appointment_id;

        // The code is creating an object named `formBody` with properties `id`
        const formBody = {
            id,
        };

        try {
            const res = await Appointments.sentFitkitMail(formBody);
            message.success('Fitkit Mail send');
        } catch (error) {
            console.error('Error:', error);
            // Handle network errors
            message.error('Error Occurred While Sending Fitkit Mail');
        }
    };

    /**
     * View the Report
     */

    function viewReport() {
        setReportModalVisible(true);
    }

    /**
     * The function "viewOutBox" sets the "OutBoxModel" to false.
     */
    function viewOutBox() {
        setOutBoxModel(false);
    }
    /**
     * The function `paymentInformation` sets the payment view to false.
     */
    function paymentInformation() {
        setPaymentView(false);
    }
    /**
     * The `handleCloseReportModal` function sets the visibility of the report send modal to false.
     */
    const handleCloseReportModal = () => {
        setReportSendModalVisible(false);
    };

    const handleClosePaymentLinkModal = () => {
        setIsModalVisible(false);
    };

    /**
     * The handleClick function handles different actions based on the key parameter passed to it.
     */
    const handleClick = (params) => {
        switch (params.key) {
            case 'view_outbox':
                setOutBoxModel(true);
                break;
            case 'fitkit_preview':
                setReportModalVisible(true);
                break;
            case 'payment_information':
                setPaymentView(true);
                break;
            // case 'resend_email':
            //     //confirmation
            //     showResendMailConfirmation();
            //     break;
            case 'google_review':
                sendGoogleReviewMail();
                break;
            case 'resend_email':
                setSendMailReportModalVisible(true);
                break;
            case 'send_fitkit':
                // confirmation
                showFitkitConfirmation();
                break;

            // case 'send_fitkit':
            //     sendFitkitMail();
            //     break;
            // case 'document_upload':
            //     uploadDocument();
            //     break;

            default:
        }
    };

    // for getting currency symbol

    // Assuming `user` is defined and has the `firm`and f_otherdetails property
    let otherDetails = user?.firm?.f_otherdetails1;

    let firmDetails = JSON.parse(otherDetails);
    let currency = firmDetails.currency_symbol;

    /**
     * Confirmation for sending fitkit mail
     */

    const showFitkitConfirmation = () => {
        confirm({
            // title: 'Confirm',
            content: 'Are you sure you want to send the Fitkit mail ?',
            onOk() {
                sendFitkitMail();
            },
            onCancel() {},
        });
    };

    /**
     *  confirmation for sending the Resend confirmation mail
     */

    const showResendMailConfirmation = () => {
        confirm({
            // title: 'Confirm',
            content: 'Are you sure you want to Resend confirmation mail ?',
            onOk() {
                resendEmails();
            },
            onCancel() {},
        });
    };

    const menu = (
        <Menu onClick={handleClick}>
            <Menu.Item key="view_outbox" className="item-discount" style={{ marginBottom: '8px' }} icon={<SendOutlined />}>
                {t('View Outbox')}
            </Menu.Item>
            <Menu.Item key="fitkit_preview" className="item-discount" style={{ marginBottom: '8px' }} icon={<EyeOutlined />}>
                {t('Fitkit Preview')}
            </Menu.Item>
            <Menu.Item key="payment_information" className="item-discount" style={{ marginBottom: '8px' }} icon={<DatabaseOutlined />}>
                {t('Payment Information')}
            </Menu.Item>
            {/* <Menu.Item key="resend_email" className="item-discount" style={{ marginBottom: '8px' }} icon={<MailOutlined />}>
                {t('Resend Confirmation Mail')}
            </Menu.Item>
            <Menu.Item key="send_fitkit" className="item-discount" style={{ marginBottom: '8px' }} icon={<MailOutlined />}>
                {t('Send Fitkit Mail')}
            </Menu.Item> */}
            <Menu.Item key="resend_email" className="item-discount" style={{ marginBottom: '8px' }} icon={<MailOutlined />}>
                Resend Mail
            </Menu.Item>
            {/* <Menu.Item key="document_upload" className="item-discount" style={{ marginBottom: '8px' }} icon={<SendOutlined />}>
                {t('Document Upload')}
            </Menu.Item> */}

            {/* {guest.da_billid ? (
                <Menu.Item key="google_review" className="item-discount" style={{ marginBottom: '8px' }} icon={<GoogleOutlined />}>
                    Sent Google Review
                </Menu.Item>
            ) : null} */}
        </Menu>
    );

    // for other bill status
    const billStatus = status.bill_additional_info;

    const appointmentOtherInformation = status.appointment_additional_info;

    return (
        <Card className="appointment-detail">
            <div className="page-header">
                <div></div>

                <div className="right">
                    {/*New Appointment */}

                    <div className="new-appointment">
                        {/* To access profile from website */}
                        {/* <div>
                            <Button
                                style={{ borderRadius: '1px' }}
                                type="primary"
                                size="small"
                                onClick={() => {
                                    accessProfile();
                                }}
                            >
                                {t('Profile')}
                            </Button>
                        </div> */}
                        {/* send report to mail  */}
                        {status.report_published ? (
                            <div>
                                <Button
                                    // style={{ borderRadius: '1px' }}
                                    type="secondary"
                                    size="small"
                                    onClick={() => {
                                        setReportSendModalVisible(true);
                                    }}
                                >
                                    <SendOutlined />
                                    {t('Send Report / Images')}
                                </Button>
                                {/*  send Report modal starts  */}
                                <Modal
                                    destroyOnClose={true}
                                    footer={null}
                                    className="payment"
                                    visible={reportSendModelVisible}
                                    //  onOk={() => {
                                    //     setVisible(true);
                                    //      }}

                                    onCancel={handleCloseReportModal}
                                    width={'60%'}
                                    maskClosable={false}
                                    closable={false} // This disables the close (X) icon
                                >
                                    <Tabs defaultActiveKey="0">
                                        {/*  send report tab starts  */}

                                        <TabPane tab={t('SEND REPORT')} key="0">
                                            {guest.prereg_id ? (
                                                <SendReport
                                                    props={props}
                                                    billId={guest.bill_id}
                                                    appointment_id={guest.appointment_id}
                                                    mail={guest.email_address}
                                                    reportModalVisible={reportSendModelVisible}
                                                    mobileNo={guest.phone_numer}
                                                    callback={handleCloseReportModal}
                                                />
                                            ) : null}
                                        </TabPane>

                                        {/*  send report tab ends  */}

                                        {/*  send image tab starts  */}

                                        <TabPane tab={t('SEND IMAGE LINK')} key="1">
                                            <SendImageLink
                                                props={props}
                                                callback={handleCloseReportModal}
                                                billId={guest.bill_id}
                                                opNo={guest.op_no}
                                                guest={guest}
                                            />
                                        </TabPane>

                                        {/*  send image tab ends  */}
                                    </Tabs>
                                </Modal>
                                {/* Send Report Model end */}
                            </div>
                        ) : null}

                        <div>
                            <Link to={'/new-registration/mode'}>
                                <Button style={{ borderRadius: '1px' }} type="primary" size="small">
                                    {t('New Appointment')}
                                </Button>
                            </Link>
                        </div>
                        {/* "Edit Appointment" button  shows if there is no da_billid against the 
                   appointment. If da_billid is present, then it renders nothing.  */}
                        {guest.bill_id ? null : (
                            <div>
                                <Button
                                    style={{ borderRadius: '1px' }}
                                    type="primary"
                                    size="small"
                                    onClick={() => {
                                        editAppointment();
                                    }}
                                >
                                    {t('Edit Appointment')}
                                </Button>
                            </div>
                        )}

                        {/* Audit Log */}
                        <div>
                            {props.auditLog?.mode ? (
                                <>
                                    <AuditLogList id={id} props={props} record_id={id} />
                                </>
                            ) : null}
                        </div>

                        {/* Document Upload Component - With Appointment */}

                        {props.enableDocumentUpload ? (
                            <DocumentUploadComponent
                                baseUrl={{ baseUrl: props.baseUrl, documentType: 'report' }}
                                da_id={guest.appointment_id}
                                bill_id={guest.bill_id}
                                op_no={guest.op_no}
                                documentMode={props.documentMode}
                                documentCode={props.documentCode}
                                reportConfig={props.reportConfig}
                                referenceId={guest.appointment_id}
                                referenceNumber={guest.op_no}
                                // {...props}

                                props={props}
                                guest={{
                                    da_id: guest.appointment_id,
                                    bill_id: guest.bill_id,
                                    op_no: guest.op_no,
                                }}
                            />
                        ) : null}
                        {/* Document Upload Component - With Appointment Ends */}

                        <div className="action-dropdown">
                            <Dropdown overlay={menu} placement="bottomLeft" trigger={['click']}>
                                <Space
                                // size="small" type="default" style={{ borderRadius: '2px solid', color: 'black' }}
                                >
                                    {t('Actions')}
                                    <DownOutlined />
                                </Space>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                {/* Outbox modal starts  */}
                <Modal
                    destroyOnClose={true}
                    visible={outBoxModel}
                    // title="Outbox"
                    footer={null}
                    className=""
                    onCancel={() => {
                        setOutBoxModel(false);
                    }}
                    width={'80%'}
                    maskClosable={false}
                >
                    <Tabs defaultActiveKey="0">
                        <TabPane tab={t('Outbox')} key="0">
                            <OutboxList filteredMail={props.filterMail} record={guest} />
                        </TabPane>
                    </Tabs>
                </Modal>

                {/* Modal for Viewing Report (fitkit preview) */}
                <Modal
                    width={'80%'}
                    height={'570px'}
                    destroyOnClose={true}
                    footer={null}
                    title={t('Fitkit Preview')}
                    visible={reportModalVisible}
                    cancelButtonProps={{ style: { display: 'none' } }}
                    okText="Close"
                    onOk={() => {
                        setReportModalVisible(true);
                    }}
                    onCancel={() => {
                        setReportModalVisible(false);
                    }}
                >
                    <PrintPreview templatecode={props.templateCode} refereneceId={id} groupPointer={props.groupPointer} props={props} />
                    {/* <BillPreview billId={id} groupPointer={props.groupPointer} templatecode={props.templatecode} /> */}
                    {/* <ReportPreview billId={billId} downloadFileName={downloadFileName} groupPointer={groupPointer} /> */}
                </Modal>

                {/* Send Mail starts  */}
                <Modal
                    destroyOnClose={true}
                    visible={sendMailModalVisible}
                    // title="Outbox"
                    footer={null}
                    className=""
                    onCancel={() => {
                        setSendMailReportModalVisible(false);
                    }}
                    width={'80%'}
                    maskClosable={false}
                >
                    {/* Print Preview Button */}
                    {guest.prereg_id ? (
                        <PreviewMails
                            templatecode={props.mailTempateCode} // Template code for message template setting as mailTempateCode in attributes
                            refereneceId={guest.appointment_id}
                            // groupPointer={props.mailToSend} // mailToSend for message template setting as mailToSend in attributes as an array
                            props={props}
                            config={{
                                mode: ['email', 'whatsapp', 'sms'],
                                templateMode: 'MessageTemplates',
                                recipient: {
                                    email: guest.prereg_email,
                                    whatsapp: guest.prereg_mobile1,
                                },
                            }}
                            sendMail={props.sendMail} // Attribute for mail textbox enable/ disableF
                        />
                    ) : (
                        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>No Data Found</div>
                    )}
                    {/* added null condition to No Data Found */}
                    {/* Print Preview Button */}
                </Modal>
                {/*Send Mail Ends */}
                {/* view payment information */}
                <Modal
                    destroyOnClose={true}
                    visible={paymentView}
                    // title="Payment"
                    footer={null}
                    className=""
                    onCancel={() => {
                        setPaymentView(false);
                    }}
                    width={'80%'}
                    maskClosable={false}
                >
                    <Tabs defaultActiveKey="0">
                        <TabPane tab={t('Payment')} key="0">
                            <PaymentList record={guest} />
                        </TabPane>
                    </Tabs>
                </Modal>

                {/* <div className="actions">
                    {guest.da_billid ? (
                        <div>
                            <Popconfirm
                                title="Are you sure you want to trigger mail for this guest ? "
                                onConfirm={() => sendGoogleReviewMail()}
                                onCancel={() => {}}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button
                                    className="billing"
                                    // type="primary"
                                    // color="green"
                                >
                                    Send Google Review Mail
                                </Button>
                            </Popconfirm>
                        </div>
                    ) : null}
                </div> */}
            </div>

            {/* Page Header Ends */}

            {/* Content Below */}
            {loading ? (
                // <>
                <Card>
                    <Skeleton active />
                </Card>
            ) : (
                // </>
                <div>
                    <div className="timeline-guest">
                        <div style={{ flexGrow: '1' }}>
                            <div className="guest-detail">
                                {/*Guest Information */}
                                <GuestInfo
                                    t={t} // To Translate to another language
                                    guest={guest}
                                    // data={status}
                                    // guestopreg={guestopreg}
                                    // guestitem={guestitem}
                                    // guestprereg={guestprereg}
                                    // guestopbill={guestopbill}
                                    // nature={nature}
                                    selected={selected}
                                    sameDay={sameDay}
                                    user={user}
                                    props={props}
                                    cancelApp={() => {
                                        // setShowAlert(true); // Show the alert
                                        setVisible(true);
                                    }}
                                />

                                {/* </div> */}
                                {/* <div className='guest-details'> */}
                                <GuestRecord
                                    record={guest}
                                    // cancelApp={() => {
                                    //     setVisible(true);
                                    // }}
                                    // guestprereg={guestprereg}
                                    // opReg={guestopreg}
                                    Id={id}
                                    props={props}
                                    // filteredMail={props.filterMail}
                                    // templateCode={props.templateCode}
                                    // groupPointer={props.groupPointer}
                                    appointment_mode={props.appointmentMode}
                                    // sameDay={sameDay}
                                />

                                {/* for cancel appointmnet alert */}
                                {guest.canflg === '*' ? (
                                    <Alert
                                        description={t('The appointment has been successfully canceled.')}
                                        type="error"
                                        showIcon
                                        style={{ marginTop: '1rem' }}
                                    />
                                ) : null}
                            </div>
                        </div>

                        <div className="status-information">
                            {/* Package Details */}
                            {/**If there is hidePriceDetails attribute then hide price by default it will not be hidden */}
                            {props.hidePriceDetails == true ? null : (
                                <Card className="card card-shadow">
                                    <Title level={5} className="guest-headings">
                                        {t('BILL DETAILS')}
                                    </Title>
                                    {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <div className="section-label">
                                            <Text type="primary">{t('SUB TOTAL')}</Text>
                                        </div>
                                    </div> */}

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <div className="section-label">
                                            <Text type="primary">{t('SUB TOTAL')}</Text>
                                        </div>
                                        {/* <Collapse defaultActiveKey={[]} ghost>
                                            <Panel header="Show Details" key="1"> */}
                                        <PriceFormatter
                                            price={selected.ir_rate}
                                            locale={firmDetails.priceFormat}
                                            enablePriceFormatting={firmDetails.enablePriceFormatting}
                                        />
                                        {/* </Panel>
                                        </Collapse> */}
                                    </div>

                                    {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <div className="section-label">
                                        <Text type="secondary">{t('SLOT')}</Text>
                                    </div>
                                    <div className="section-value">
                                        <strong> {moment(guest.appointment_date).format('DD/MM/YYYY')}</strong>
                                    </div>
                                </div> */}

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <div className="section-label">
                                            <Text type="secondary">{t('COUPON DISCOUNT')}</Text>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        {guest.coupon_no ? (
                                            // <Collapse defaultActiveKey={[]} ghost>
                                            // <Panel header="Show Details" key="1">
                                            <PriceFormatter
                                                price={guest.coupon_value}
                                                locale={firmDetails.priceFormat}
                                                enablePriceFormatting={firmDetails.enablePriceFormatting}
                                            />
                                        ) : // </Panel>
                                        // </Collapse>
                                        null}
                                    </div>

                                    {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <div className="section-label">
                                            <Text type="secondary">{t('BILL VALUE')}</Text>
                                        </div>
                                    </div> */}

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <div className="section-label">
                                            <Text type="secondary">{t('BILL VALUE')}</Text>
                                        </div>
                                        {/* <Collapse defaultActiveKey={[]} ghost>
                                            <Panel header="Show Details" key="1"> */}
                                        <PriceFormatter
                                            price={guest.bill_value}
                                            locale={firmDetails.priceFormat}
                                            enablePriceFormatting={firmDetails.enablePriceFormatting}
                                        />
                                        {/* </Panel> */}
                                        {/* </Collapse> */}
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <div className="section-label">
                                            <Text type="secondary">{t('BILL DISCOUNT')}</Text>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        {guest.bill_discount_amt && guest.bill_discount_amt !== 0 ? (
                                            // <Collapse defaultActiveKey={[]} ghost>
                                            //     <Panel header="Show Details" key="1">
                                            <PriceFormatter
                                                price={guest.bill_discount_amt}
                                                locale={firmDetails.priceFormat}
                                                enablePriceFormatting={firmDetails.enablePriceFormatting}
                                            />
                                        ) : //     </Panel>
                                        // </Collapse>
                                        null}
                                    </div>

                                    <Divider type="vertical" className="custom-divider" />

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                        <div className="section-label">
                                            <Text type="secondary">{t('Net Amount')}</Text>
                                        </div>
                                        <PriceFormatter
                                            price={guest.net_amount}
                                            locale={firmDetails.priceFormat}
                                            enablePriceFormatting={firmDetails.enablePriceFormatting}
                                        />
                                        {/* <div className="section-value">
                                        <strong>{guest.da_billvalue}</strong>
                                    </div> */}
                                    </div>
                                </Card>
                            )}
                            <Card className="card-shadow card">
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <div className="section-label">
                                        <Text type="secondary">{t('PAYMENT STATUS')}</Text>
                                    </div>
                                    <div className="section-value">
                                        {/* payment status model start */}
                                        {props.enablePaymentStatusUpdate ? (
                                            <StatusChange
                                                description={status.payment_status}
                                                callback={refresh}
                                                id={id}
                                                statusValue={status.payment_status_code}
                                                // status mode
                                                mode="PAY"
                                                // mode of status for api call
                                                apiMode="PAY"
                                                name="payment status"
                                                disabled={status.paid_status}
                                            />
                                        ) : (
                                            <div>{status.payment_status}</div>
                                        )}

                                        {/* payment status model end */}
                                    </div>
                                </div>
                            </Card>
                            {/* Other information start */}
                            {appointmentOtherInformation && appointmentOtherInformation.length ? (
                                <Card className="critical-info">
                                    <Title level={5} className="guest-headings">
                                        CRITICAL INFORMATION
                                    </Title>
                                    {/* <p level={5}>CRITICAL INFORMATION</p> */}
                                    {appointmentOtherInformation.map((ele, index) => (
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                            <div className="section-label">
                                                <Text type="secondary" key={index}>
                                                    {ele.item_desc}
                                                </Text>
                                            </div>
                                        </div>
                                    ))}
                                </Card>
                            ) : null}

                            {/* coupon message start */}

                            <Coupon
                                visible={guest.coupon_info}
                                couponDetails={guest.coupon_info}
                                currency={currency}
                                isSuccess={guest.coupon_info}
                                showInfoIcon={guest.coupon_info}
                            />
                            {/* coupon message end */}

                            {/* Other Bills Start */}
                            {billStatus && billStatus.length ? (
                                <Card className="card card-shadow">
                                    <Title level={5} className="guest-headings">
                                        {t('OTHER INFORMATION')}
                                    </Title>
                                    {billStatus.map((bill, index) => (
                                        <div
                                            // key={index}
                                            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}
                                        >
                                            <div className="section-label">
                                                <Text type="secondary">{bill.item_desc}</Text>
                                            </div>
                                            {/* <div className="section-value"> */}
                                            {/* {bill.status ?  */}
                                            {/* <strong></strong><Tag color="orange">Pending</Tag> */}
                                            {/* } */}
                                            {/* </div> */}
                                        </div>
                                    ))}
                                </Card>
                            ) : null}

                            {/* Other Bills End */}

                            {/* Process Status */}

                            <>
                                {status ? (
                                    <Card className="card-shadow card">
                                        <Title level={5} className="guest-headings">
                                            {t('PROCESS STATUS')}
                                        </Title>

                                        <Row justify="space-between" style={{ marginBottom: '16px' }}>
                                            <Col span={18}>
                                                <Text type="secondary"> {t('FITKIT STATUS')} </Text>
                                            </Col>
                                            <Col span={6} style={{ textAlign: 'right' }}>
                                                {status.fitkit_status ? (
                                                    <strong>{status.fitkit_status}</strong>
                                                ) : (
                                                    <Tag color="orange">{t('Pending')}</Tag>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row justify="space-between" style={{ marginBottom: '16px' }}>
                                            <Col span={18}>
                                                <Text type="secondary"> {t('BILL PAID:')} </Text>
                                            </Col>
                                            <Col span={6} style={{ textAlign: 'right' }}>
                                                {status.billed_status === 'Billed' ? (
                                                    <Tag color="green">{status.billed_status}</Tag>
                                                ) : (
                                                    <Tag color="orange">{t('Pending')}</Tag>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row justify="space-between" style={{ marginBottom: '16px' }}>
                                            <Col span={18}>
                                                <Text type="secondary"> {t('GENETIC SAMPLE STATUS')} </Text>
                                            </Col>
                                            <Col span={6} style={{ textAlign: 'right' }}>
                                                {status.sample_status ? (
                                                    <strong>{status.sample_status}</strong>
                                                ) : (
                                                    <Tag color="orange">{t('Pending')}</Tag>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row justify="space-between" style={{ marginBottom: '16px' }}>
                                            <Col span={18}>
                                                <Text type="secondary"> {t('PHYSICIAN VERIFIED')} </Text>
                                            </Col>
                                            <Col span={6} style={{ textAlign: 'right' }}>
                                                {status.physician_verified === 'Verified' ? (
                                                    <Tag color="green">{status.physician_verified}</Tag>
                                                ) : (
                                                    <Tag color="orange">{status.physician_verified}</Tag>
                                                )}
                                            </Col>
                                        </Row>

                                        <Row justify="space-between" style={{ marginBottom: '16px' }}>
                                            <Col span={18}>
                                                <Text type="secondary">{t('REPORT PUBLISHED')} </Text>
                                            </Col>
                                            <Col span={6} style={{ textAlign: 'right' }}>
                                                {status.report_published ? (
                                                    <Tag color="green">{t('Published')}</Tag>
                                                ) : (
                                                    <Tag color="orange">{t('Pending')}</Tag>
                                                )}
                                            </Col>
                                        </Row>

                                        {!props.disableReportStatus && (
                                            <Row justify="space-between" style={{ marginBottom: '16px' }}>
                                                <Col span={18}>
                                                    <Text type="secondary">{t('HARD COPY REPORT STATUS')}</Text>
                                                </Col>
                                                <Col span={6} style={{ textAlign: 'right' }}>
                                                    {status.report_status ? (
                                                        <strong>{status.report_status}</strong>
                                                    ) : (
                                                        <Tag color="orange">{t('Pending')}</Tag>
                                                    )}
                                                </Col>
                                            </Row>
                                        )}

                                        {!props.disableReportReadyMailSend && (
                                            <Row justify="space-between" style={{ marginBottom: '16px' }}>
                                                <Col span={18}>
                                                    <Text type="secondary">{t('REPORT READY MAIL SEND:')} </Text>
                                                </Col>
                                                <Col span={6} style={{ textAlign: 'right' }}>
                                                    {status.reportmail_sendstatus === 'Send' ? (
                                                        <Tag color="green">{status.reportmail_sendstatus}</Tag>
                                                    ) : (
                                                        <Tag color="orange">{status.reportmail_sendstatus}</Tag>
                                                    )}
                                                </Col>
                                            </Row>
                                        )}
                                    </Card>
                                ) : null}
                            </>

                            {/* Process status Done */}
                            {/* Consent Status */}
                            {props.enableConsentUpload ? (
                                <AppointmentConsent
                                    callback={refresh}
                                    mode="appointment"
                                    value={guest.consent_scannedstatus}
                                    id={guest.appointment_id}
                                    props={props}
                                    onPremiseUrl={props.onPremiseUrl}
                                    documentMode={props.documentMode}
                                    billId={guest.bill_id}
                                />
                            ) : null}

                            {/* Consent Status Done*/}
                            <br></br>
                            {props.enableIdUpload ? (
                                <UploadId
                                    callback={refresh}
                                    uploaded_status={status.corporate_id_uploaded_status}
                                    upload_status={status.corporate_id_upload_status}
                                    id={guest.appointment_id}
                                    corporate_ptr={guest.corporate_ptr}
                                    props={{ reportConfig: props.reportConfig, onPremiseUrl: props.onPremiseUrl }}
                                    documentMode={props.documentMode}
                                    guest={guest}
                                ></UploadId>
                            ) : null}
                        </div>

                        {/* <div> */}
                        {/* <Tabs defaultActiveKey="0">
                                <TabPane tab="Outbox" key="0">
                                    <OutboxList record={guest} />
                                </TabPane>
                            </Tabs> */}
                        {/* </div> */}

                        {/*Appointment Timeline */}
                        {/* <AppointmentTimeline guest={guest} guestopreg={guestopreg} guestitem={guestitem} /> */}
                    </div>
                </div>
            )}
            {/* Modal for Cancel Appointment */}
            <Modal
                destroyOnClose={true}
                title={t('Cancel Appointment')}
                visible={visible}
                okText="Okay"
                onOk={() => {
                    setVisible(false);
                    onCancelAppointment();
                }}
                onCancel={() => {
                    setVisible(false);
                }}
            >
                <Form {...layout} form={form} name="new-record" layout="vertical">
                    <Form.Item
                        name={'remarks'}
                        label={t('Remarks')}
                        rules={[
                            {
                                required: true,
                                whitespace: true,
                                message: 'Please enter Remarks',
                            },
                            {
                                max: 100,
                                message: 'Remarks cannot exceed 100 characters',
                            },
                        ]}
                    >
                        <TextArea rows={4} showCount maxLength={100} />
                    </Form.Item>
                </Form>

                {/* Alert Component */}
            </Modal>
        </Card>
    );
}

function GuestRecord({ Id, record, props }) {
    const [visible, setVisible] = useState(false);

    //  for model change profile
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [showOtp, setShowOtp] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [reportModalVisible, setReportModalVisible] = useState(false);
    // This variable used to open complete profile modal

    const [profileModalVisible, setProfileModalVisible] = useState(false);
    const { t, i18n } = useTranslation(); // To Translate to another language

    const appointmentId = record?.appointment_id;

    function handleChangeProfile() {
        Location.navigate({
            url: `/change-profile?appointmentId=${appointmentId}`,
        });
    }

    // /**
    //  *
    //  */
    // async function resendEmails() {
    //     const result = await ApiUtils.get({ url: `mail/resend-appointment-details?id=${record.appointment_id}` });

    //     message.success('Mail/SMS Confirmation send');
    // }
    //Appointment data fiiling for icarus
    function CompleteProfile() {
        Location.navigate({
            url: `/new-registrations/complete-profile?da_id=${record.appointment_id}&da_packagetypevalue=${record.packagetypevalue}&id=${
                record.reference_id
            }&prereg_opno=${record.op_no}&mode=call&selected_time=${moment(record.appointment_date).format('DD/MM/YYYY')}&complete_profile=true`,
        });
    }

    const handleCompleteProfile = () => {
        setProfileModalVisible(true);
    };
    // /**
    //  * New Registration
    //  *
    //  *
    //  */

    // function register() {
    //     Location.navigate({
    //         url: `/new-registrations/registration?id=${guestprereg.prereg_id}&appointmentId=${record.appointment_id}&redirect=appointment`,
    //     });
    // }

    const handleCloseModal = () => {
        setProfileModalVisible(false);
    };

    // /**
    //  * Redirect to bill if the customer is registered but not billed
    //  */
    // function proceedBilling() {
    //     Location.navigate({
    //         url: `/multiple-candidate/bill?op_no=${opReg.op_no}&appointmentId=${record.appointment_id}`,
    //     });
    // }

    /**
     * View the Report
     */

    function viewReport() {
        setReportModalVisible(true);
    }

    // function proceedRegistration() {
    //     var selected_time = moment(record.da_date).format('DD/MM/YYYY') + record.da_aptime;

    //     let url = `/new-registration/guest?da_id=${record.da_id}&prereg_id=${record.da_referenceid}&da_packagetypevalue=${record.da_packagetypevalue}&selected_time=${selected_time}&token_no=${record.da_tokenno}`;

    //      Location.navigate({ url: url });
    // }

    // for icarus flow (complete profile).

    // const inCompleteProfile = guestprereg?.prereg_otherdetails1;

    // let profileStatus = null;
    // if (inCompleteProfile) {
    //     try {
    //         const parsedInCompleteProfile = JSON.parse(inCompleteProfile);
    //         profileStatus = parsedInCompleteProfile.profile; // Access the value associated with the "profile" key
    //     } catch (error) {
    //         console.error('Error parsing JSON:', error);
    //     }
    // }

    return (
        <>
            {/* Cancel Appointment, Billing, Registration */}

            {/*Billing */}

            <Card className="guest-info card-shadow card" style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                    {record.reference_id == -1 && (
                        <Alert
                            style={{ fontSize: '10px', flex: 1 }}
                            message="Please complete your profile in order to complete your registration and access all services at Nura"
                            type="info"
                            showIcon
                            onClose={CompleteProfile}
                            className="custom-alert"
                            action={
                                <Button type="primary" size="small" onClick={handleCompleteProfile}>
                                    Complete Profile
                                </Button>
                            }
                        />
                    )}
                    <Modal
                        // title="MODE OF APPOINTMENT"
                        destroyOnClose={true}
                        className="payment"
                        visible={profileModalVisible}
                        onCancel={handleCloseModal}
                        width={'67%'}
                        height={'50%'}
                        maskClosable={false}
                        footer={null}
                    >
                        <ProfileModel
                            props={props}
                            values={record}
                            billingDetails={record.other_details}
                            pacakageValue={record.packagetypevalue}
                            tokenNo={record.tokenno}
                            Id={record.appointment_id}
                        />
                    </Modal>
                    {/* change profile alert start*/}
                    {record?.duplicate_prereg === true && (
                        <Alert
                            style={{ fontSize: '10px', flex: 1 }}
                            message="Please update profile to avoid your duplicates and ensure all appointments are linked correctly"
                            type="info"
                            showIcon
                            // onClose={ChangeProfile}
                            className="custom-alert"
                            action={
                                <Button type="primary" size="small" onClick={handleChangeProfile}>
                                    Change Profile
                                </Button>
                            }
                        />
                    )}
                </div>
                {/* {record.op_no && !record.da_billid ? ( */}
                <>
                    <div>
                        {/* <Button
                                className="billing"
                                onClick={() => {
                                    proceedBilling();
                                }}
                                type="secondary"
                                shape="round"
                                style={{ background: "#FAC141" }}
                                // size="small"
                                color="green"
                            >
                                Proceed for Billing
                            </Button> */}
                    </div>
                </>
                {/* ) : null} */}
                {/*Registration  */}
                {/* {!record.da_newopno ? ( */}
                <>
                    {/* <div>
                            <Button
                                className="billing"
                                onClick={() => {
                                    proceedRegistration();
                                }}
                                type="secondary"
                                shape="round"
                                style={{ background: '#FAC141' }}
                                // size="small"
                                color="green"
                            >
                                Proceed for Registration
                            </Button>
                        </div> */}
                </>
                {/* ) : null} */}

                {/* Cancel and Reschedule Appointment */}

                {/* <ConfirmModal */}
                {/* caption={'Resend Appointment Confirmation Mails'} */}
                {/* title={t( */}
                {/* 'This action will send the Appointment Confirmation , Questionnaire and Access Credentials to the Customers Email and Phone , Are you sure ? ' */}
                {/* )} */}
                {/* callback={values => resendEmails()} */}
                {/* > */}
                {/* <Button */}
                {/* className="billing" */}
                {/* type="primary" */}
                {/* // // size="small" */}
                {/* // shape="round" */}
                {/* // style={{ background: "#FAC141" }} */}
                {/* color="green" */}
                {/* > */}
                {/* Resend Appointment Confirmation Mails */}
                {/* </Button> */}
                {/* </ConfirmModal> */}

                {/* <Popconfirm
                    title="This action will send the Appointment Confirmation , Questionnaire and Access Credentials to the Customers Email and Phone , Are you sure ? "
                    onConfirm={() => resendEmails()}
                    onCancel={() => { }}
                    okText="Yes"
                    cancelText="No"
                >

                </Popconfirm> */}
                <div className="new-appointment ">
                    {/* {!record.da_billid ? (
                        <div style={{ display: 'flex', gap: '10px' }}>
                            Cancel Appointment
                            <Popconfirm
                                title={t('Are you sure you want to cancel this appointment ? ')}
                                onConfirm={() => cancelApp()}
                                onCancel={() => { }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button
                                    className="billing"
                                    
                                    size="small"
                                   
                                    style={{ paddingBottom: '1rem', border: '1px solid red', color: 'red' }}
                                    color="green"
                                >
                                    {t('Cancel Appointment')}
                                </Button>
                            </Popconfirm>

                            Cancel Appointment Ends
                        </div>
                    ) : null} */}
                    {/* <div style={{ display: 'flex', gap: '10px' }}> */}
                    <>
                        {/* <Button
                                type="secondary"
                                size="small"
                                disabled={opReg || sameDay === false ? true : false || record.da_referenceid == -1}
                                onClick={register}
                            >
                                Register
                            </Button> */}
                    </>
                    <div className="guest-footer">
                        <Title level={5} className="guest-headings">
                            {t('REGISTERED BY')}
                        </Title>{' '}
                        <div className="guest-description">
                            <span style={{ fontSize: '9px' }}>
                                {t('Last Updated By')} - {record.user} for {moment(record.appointment_date).format('DD/MM/YYYY')},
                                {record.appointment_time} .{/* on{' '} */}
                                {t('Updated Time')} - {moment.tz(record.updated_time, 'DD MM YYYY hh:mm a').format('DD/MM/YYYY, hh:mm a')}.
                            </span>
                        </div>
                    </div>
                    {/* {(sameDay && !record.da_billid && opReg) || (!record.da_newopno && guestprereg && guestprereg.prereg_opno) ? (
                            <Button size="small" type="secondary" onClick={proceedBilling}>
                                {t('Proceed to Bill')}
                            </Button>
                        ) : null} */}
                    {/* </div> */}
                </div>
            </Card>
        </>
    );
}

/**
 * Component would show the appointment consent current status ,
 * If the value does not have value , the user can upload new consent
 *
 * @param {*} param0
 * @returns
 */
function AppointmentConsent({ id, value, callback, props, onPremiseUrl, documentMode ,billId}) {
    const [openPreview, setOpenPreview] = useState(false);

    const [openIframe, setOpenIframe] = useState(false);

    const { t, i18n } = useTranslation(); // To Translate to another language

    const [consentModalVivisible, setConsentModalVisible] = useState(false);

    /**
     * Function to upload consent form
     *
     * @param {*} dataUri
     */
    const onConsentUpload = (selectedImages, baseIndex = 0) => {
        message.loading('Uploading Consent Document');

        // var formData = new FormData();
        Promise.all(
            selectedImages.map((ele, index) => {
                var formData = new FormData();

                // setting body
                formData.append('files', ele);
                formData.append('appointment_id', id);
                formData.append('index', baseIndex + (index + 1));
                formData.append('document_code', 'CST');
                formData.append('docdet_refmode', documentMode);

                // setting body
                // let formBody = {
                //     files: ele,
                //     appointment_id: id,
                //     index: baseIndex + (index + 1),
                //     document_code: 'CST',
                //     docdet_refmode: documentMode,
                // };
                // set headers for consent
                let headers = {
                    db_ptr: localStorage.db_ptr ? localStorage.db_ptr : process.env.REACT_APP_DB_PTR,
                    Authorization: 'Bearer ' + localStorage.access_token,
                };
                return DocDetails.documentUpload(formData, onPremiseUrl, headers).then((result) => {
                    if (result.message === 'success') {
                        return result;
                    }
                });
            })
        ).then((result) => {
            // refreshing page after consent upload
            if (result[0].success) {
                message.success('File Uploaded SuccessFully');

                callback();
            } else {
                message.error('File Upload Failed');

                callback();
            }
        });
    };

    return (
        <div className="card-shadow card">
            {/* <Button
                size="middle"
                type="primary"
                onClick={() => {
                    setOpenIframe(true)
                }}
            >
                Take Picture
            </Button> */}
            {/* <Row span={12}> */}
            <Title level={5} className="guest-headings">
                {t('CONSENT DOCUMENT INFORMATION')}
            </Title>
            {/* </Row> */}
            {/* <Row span={12}> */}
            <span>
                {value ? (
                    <div>
                        <div className="consent-file-upload-wrapper">
                            <Button
                                className="consent-file-upload-btn"
                                type="primary"
                                onClick={() => {
                                    setConsentModalVisible(true);
                                }}
                            >
                                <EyeOutlined/> View Document
                            </Button>

                            <Modal
                                visible={consentModalVivisible}
                                onCancel={() => {
                                    setConsentModalVisible(false);
                                }}
                                footer={null}
                                width="45%"
                            >
                                <ConsentUploader id={id} onPremiseUrl={onPremiseUrl} documentMode={documentMode}  callback={callback} documentCode={props.documentCode} props={props} billId={billId}/>
                            </Modal>
                        </div>
                        {/* <DocumentPreview id={id} /> */}
                    </div>
                ) : (
                    <>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <div className="section-label">
                                <Text type="secondary">{t('STATUS')}</Text>
                            </div>
                            <div className="section-value">
                                <Tag color="orange">{t('Pending')}</Tag>
                            </div>
                        </div>

                        {/* Camera Component with Advanced View */}
                        {/* Camera Component with Advanced View Ends */}

                        {/* Upload Consent Document */}
                        <div className="consent-file-upload-wrapper">
                            <Button
                                className="consent-file-upload-btn"
                                type="primary"
                                icon={<FileAddOutlined />}
                                onClick={() => {
                                    setConsentModalVisible(true);
                                }}
                            >
                                Upload Document
                            </Button>

                            <Modal
                                visible={consentModalVivisible}
                                onCancel={() => {
                                    setConsentModalVisible(false);
                                }}
                                footer={null}
                                width="45%"
                            >
                                <ConsentUploader id={id}  onPremiseUrl={onPremiseUrl} documentMode={documentMode} props={props} callback={callback} documentCode={props.documentCode}  billId={billId}/>
                            </Modal>
                        </div>
                    </>
                )}

                {props.enableConsentWithPdfUpload ? <ConsentComponent app_id={id} callback={callback} /> : null}
            </span>
            {/* </Row> */}
            <Modal
                width={'100%'}
                destroyOnClose={true}
                title={t('Consent File')}
                visible={openPreview}
                okText="Okay"
                onOk={() => {
                    setOpenPreview(false);
                }}
                onCancel={() => {
                    setOpenPreview(false);
                }}
            >
                <DocumentPreview
                    id={id}
                    onDocumentUpload={onConsentUpload}
                    props={{ reportConfig: props.reportConfig, onPremiseUrl: props.onPremiseUrl, type: 'CST' }}
                />
                {/* <iframe allow="camera; microphone" align="center" src={`http://localhost:3000/document-preview/${id}?token=${localStorage.access_token}`} width="100%" height="400px"></iframe> */}
            </Modal>
            {/* <Modal
                wrapClassName="advanced-camera"
                bodyStyle={{ height: "80vh" }}
                width={'100%'}
                destroyOnClose={true}
                // title="Nura desk"
                visible={openIframe}
                okText="Okay"
                onOk={() => {
                    setOpenIframe(false);
                }}
                onCancel={() => {
                    setOpenIframe(false);
                }}
            >
                <iframe align="center" src={`http://localhost:3001/nura-desk/appointment/60271?token=${localStorage.access_token}`} width="100%" height="400px"></iframe>
                <iframe allow="camera; microphone" align="center" src={`http://localhost:3000/advanced-camera/${id}?token=${localStorage.access_token}`} width="100%" height="100%"></iframe>
            </Modal> */}
        </div>
    );
}
